import type { MutationUpdaterFn } from '@apollo/client';

import { updateCache } from 'src/modules/apollo/apolloCache';
import type {
  DeleteRoleMutation,
  RejectRoleMutation,
  UpdateRoleMutation,
  ConfirmRoleMutation,
} from 'src/types/graphql';

export const updateCacheUpdateRole: MutationUpdaterFn<UpdateRoleMutation> = (
  cache,
  { data },
) => {
  const { updateRole } = data || {};
  const confirmedRoles = updateRole?.viewer?.confirmedRoles;

  // Update cache with server data
  if (confirmedRoles) {
    updateCache({ cache, data: confirmedRoles, fieldName: 'confirmedRoles' });
  }
};

export const updateCacheDeleteRole: MutationUpdaterFn<DeleteRoleMutation> = (
  cache,
  { data },
) => {
  const { deleteRole } = data || {};
  const confirmedRoles = deleteRole?.viewer?.confirmedRoles;

  // Update cache with server data
  if (confirmedRoles) {
    updateCache({ cache, data: confirmedRoles, fieldName: 'confirmedRoles' });
  }
};

export const updateCacheConfirmRoleMutation: MutationUpdaterFn<
  ConfirmRoleMutation
> = (cache, { data }) => {
  const { confirmRole } = data || {};
  const confirmedRoles = confirmRole?.viewer?.confirmedRoles;
  const unconfirmedRoles = confirmRole?.viewer?.unconfirmedRoles;

  // Update cache with server data
  if (confirmedRoles) {
    updateCache({ cache, data: confirmedRoles, fieldName: 'confirmedRoles' });
  }
  if (unconfirmedRoles) {
    updateCache({
      cache,
      data: unconfirmedRoles,
      fieldName: 'unconfirmedRoles',
    });
  }
};

export const updateCacheRejectRoleMutation: MutationUpdaterFn<
  RejectRoleMutation
> = (cache, { data }) => {
  const { rejectUnconfirmedData } = data || {};

  // Refresh store with server data
  if (rejectUnconfirmedData?.viewer?.unconfirmedRoles) {
    const { unconfirmedRoles } = rejectUnconfirmedData.viewer;
    updateCache({
      cache,
      data: unconfirmedRoles,
      fieldName: 'unconfirmedRoles',
    });
  }
};
